import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ol>
                <li>
                  Alfonso, D., Perpina, C., P&eacute;rez-Navarro, A., Penˇ alvo,
                  E., Vargas, C., Cardenas, R., 2009. Methodology
                  for&nbsp;&nbsp; optimization of&nbsp; distributed&nbsp;
                  biomass resources evaluation, management and final energy use.
                  Biomass Bioenergy 33,&nbsp; 1070&ndash;1079.
                </li>
                <li>
                  Angelis-Dimakis,&nbsp; A.,&nbsp;&nbsp; Biberacher,&nbsp;
                  M.,&nbsp;&nbsp; Dominguez,&nbsp; J.,&nbsp;&nbsp;
                  Fiorese,&nbsp; G.,&nbsp;&nbsp; Gadocha,&nbsp; S., Gnansounou,
                  E., et al.,&nbsp; 2011. Methods and tools to evaluate the
                  availability of renewable energy sources. Renewable
                  Sustainable Energy Rev.&nbsp; 15,&nbsp; 1182&ndash;1200.
                </li>
                <li>
                  Arodudu, O., Helming, K., Wiggering, H., Voinov, A., 2017.
                  Towards a more holistic sustainability assessment framework
                  for&nbsp; agro-bioenergy systems &mdash; a review. Environ.
                  Impact Assess. Rev.&nbsp; 62,&nbsp; 61&ndash;75.
                </li>
                <li>
                  Azapagic, A., Chalabi, Z., Fletcher, T., Grundy, C., Jones,
                  M., Leonardi, G., et al.,&nbsp; 2013. An&nbsp; integrated
                  approach to assessing the environmental and health impacts of
                  pollution in the urban environment: methodology and a case
                  study. Process. Safe.&nbsp; Environ. Prot. 91,&nbsp;
                  508&ndash;520.
                </li>
                <li>
                  Baan, L.De.,&nbsp; Alkemade, R., Koellner, T., 2013. Land use
                  impacts on biodiversity in LCA: a global approach. Int.&nbsp;
                  J. Life Cycle Assess. 18,&nbsp; 1216&ndash;1230.
                </li>
                <li>
                  Beccali, M.,&nbsp; Columba, P., D&rsquo;Alberti, V.,
                  Franzitta, V., 2009. Assessment of&nbsp; bioenergy
                  potential&nbsp; in Sicily: a GIS-based support&nbsp;
                  methodology. Biomass Bioenergy 33, 79&ndash;87.
                </li>
                <li>
                  Bengtsson, M.,&nbsp; Carlson, R., Molander, S., Steen, B.,
                  1998. An&nbsp; approach for&nbsp; handling geographical
                  information in life&nbsp; cycle assessment using a relational
                  database. J. Hazard. Mater. 61,&nbsp; 67&ndash;75.
                </li>
                <li>
                  Botha, T., von Blottnitz, H.,&nbsp; 2006. A comparison
                  of&nbsp; the environmental benefits of bagasse-derived
                  electricity and fuel ethanol on a life-cycle basis. Energy
                  Policy 34,&nbsp; 2654&ndash;2661.
                </li>
                <li>
                  Butnar,&nbsp; I.,&nbsp; Rodrigo,&nbsp; J.,&nbsp; Gasol,&nbsp;
                  C.M.,&nbsp;&nbsp; Castells,&nbsp; F.,&nbsp; 2010.&nbsp;
                  Life-cycle assessment&nbsp;&nbsp; of electricity&nbsp;
                  from&nbsp; biomass:&nbsp; case&nbsp; studies&nbsp;
                  of&nbsp;&nbsp; two&nbsp; biocrops&nbsp; in&nbsp; Spain.
                  Biomass Bioenergy 34,&nbsp; 1780&ndash;1788.
                </li>
                <li>
                  Cherubini, F., Bird,&nbsp; N.D., Cowie, A., Jungmeier, G.,
                  Schlamadinger, B., Woess-Gallasch, S.,&nbsp; 2009.&nbsp;
                  Energy-and&nbsp; greenhouse&nbsp; gas-based&nbsp; LCA&nbsp;
                  of&nbsp;&nbsp; biofuel and&nbsp; bioenergy systems: &nbsp;key
                  issues, ranges and recommendations.&nbsp; Resour. Conserv.
                  Rec.&nbsp; 53, 434&ndash;447.
                </li>
                <li>
                  Choudhary, S., Liang, S., Cai,&nbsp; H.,&nbsp; Keoleian, G.A.,
                  Miller, S.A., Kelly,&nbsp; J., Xu,&nbsp; M.,&nbsp; 2014.
                  Reference and functional unit can change bioenergy pathway
                  choices. Int.&nbsp; J. Life Cycle Assess. 19,&nbsp;
                  796&ndash;805.
                </li>
                <li>
                  Contreras,&nbsp; A.M.,&nbsp;&nbsp; Rosa,&nbsp; E.,&nbsp;&nbsp;
                  P&eacute;rez,&nbsp; M.,&nbsp;&nbsp; van&nbsp;
                  Langenhove,&nbsp; H.,&nbsp;&nbsp; Dewulf,&nbsp;
                  J.,&nbsp;&nbsp; 2009. Comparative life&nbsp; cycle
                  assessment&nbsp; of&nbsp; four alternatives for&nbsp; using
                  by-products of cane sugar production. J. Clean. Prod.
                  17,&nbsp; 772&ndash;779.
                </li>
                <li>
                  Danielsen, F., Beukema, H., Burgess, N.D.,&nbsp; Parish, F.,
                  Br&uuml;hl, C.A., Donald, P.F., et al., 2009. Biofuel
                  plantations&nbsp; on forested lands: double jeopardy for&nbsp;
                  biodiversity and climate. Conserv. Biol.&nbsp; 23,&nbsp;
                  348&ndash;358.
                </li>
                <li>
                  Dresen, B., Jandewerth, M., 2012. Integration of spatial
                  analyses into LCA-calculating GHG emissions with
                  geoinformation systems. Int.&nbsp; J. Life Cycle Assess.
                  17,&nbsp; 1094&ndash; 1103.
                </li>
                <li>
                  Ebadian, M.,&nbsp; Sowlati, T., Sokhansanj, S., Stumborg,
                  M.,&nbsp; Townley-Smith, L., 2011. A new&nbsp;
                  simulation&nbsp; model&nbsp; for&nbsp;&nbsp;
                  multi-agricultural&nbsp; biomass&nbsp; logistics system&nbsp;
                  in bioenergy production. Biosys. Eng.&nbsp; 110,
                  280&ndash;290.
                </li>
                <li>
                  Egbendewe-Mondzozo, A., Swinton, S.M., Izaurralde, C.R.,
                  Manowitz, D.H., Zhang, X., 2011. Biomass supply from
                  alternative cellulosic crops and crop residues: a
                  spatially&nbsp; explicit&nbsp; bioeconomic&nbsp;
                  modeling&nbsp; approach.&nbsp; Biomass Bioenergy 35,
                  4636&ndash;4647.
                </li>
                <li>
                  Fargione, J., Hill,&nbsp; J., Tilman, D., Polasky, S.,
                  Hawthorne, P., 2008. Land clearing and the biofuel carbon
                  debt. Science 319, 1235&ndash;1238.
                </li>
                <li>
                  Ferrarini,&nbsp; A.,&nbsp; Serra,&nbsp; P.,&nbsp;
                  Almagro,&nbsp; M.,&nbsp;&nbsp; Trevisan,&nbsp; M.,&nbsp;&nbsp;
                  Amaducci,&nbsp; S.,&nbsp; 2014.&nbsp; Linking bioenergy and
                  ecological services along field margins:&nbsp; The&nbsp;&nbsp;
                  HEDGE-BIOMASS project. In:&nbsp;&nbsp; 22nd&nbsp; European
                  Biomass Conference and Exhibition, 23&ndash;26 June 2014,
                  Hamburg, Germany.
                </li>
                <li>
                  Fiedler, P., Lange, M., Schultze, M., 2007. Supply logistics
                  for&nbsp; the industrialized use of&nbsp; biomass &ndash;
                  principles and planning approach, LINDI&nbsp; 2007, In:&nbsp;
                  International Symposium on Logistics and Industrial
                  Informatics, 13&ndash;15 September, 2007, Wildau, Germany.
                </li>
                <li>
                  Foody, G.M., &nbsp;2002. Status of land cover classification
                  accuracy assessment. Remote Sens. Environ. 80.&nbsp; 185e201.
                </li>
                <li>
                  Garcia, D.A., Sangiorgio, S., Rosa, F., 2015. Estimating the
                  potential biomasses energy source of&nbsp; forest and
                  agricultural residues in the Cinque Terre Italian National
                  Park. Energy Procedia 82,&nbsp; 674&ndash;680.
                </li>
                <li>
                  Gasol,&nbsp; C.M.,&nbsp;&nbsp; Gabarrell,&nbsp; X.,&nbsp;
                  Rigola,&nbsp; M.,&nbsp;&nbsp;
                  Gonz&aacute;lez-Garc&iacute;a,&nbsp; S.,&nbsp;
                  Rieradevall,&nbsp; J.,&nbsp; 2011.
                  <br />
                  Environmental assessment: (LCA)&nbsp; and spatial modelling
                  (GIS)&nbsp; of&nbsp; energy crop implementation on local
                  scale. Biomass Bioenergy 35,&nbsp; 2975&ndash;2985.
                </li>
                <li>
                  Geyer, R., Lindner, J.P., Stoms, D.M.,&nbsp; Davis,
                  F.W.,&nbsp; Wittstock, B., 2010. Coupling GIS and LCA
                  for&nbsp; biodiversity assessments of&nbsp; land use Part 1:
                  inventory modeling. Int.&nbsp; J. Life Cycle Assess. 15,&nbsp;
                  454&ndash;467.
                </li>
                <li>
                  Geyer, R., Stoms, D., Kallaos, J., 2013. Spatially-explicit
                  life&nbsp; cycle assessment of sun- to-wheels transportation
                  pathways in the U.S. Environ. Sci.&nbsp; Technol. 47,&nbsp;
                  1170&ndash; 1176.
                </li>
                <li>
                  Gibbs, H.K.,&nbsp; Johnston, M.,&nbsp; Foley, J.A., Holloway,
                  T., Monfreda, C., Ramankutty,&nbsp; N., Zaks, D., 2008. Carbon
                  payback times for&nbsp; crop-based biofuel expansion in the
                  tropics: the effects of&nbsp; changing yield and&nbsp;
                  technology. Environ. Res.&nbsp;&nbsp; Lett. 3, 034001.
                </li>
                <li>
                  Gnansounou,&nbsp; E.,&nbsp; Vaskan,&nbsp; P.,&nbsp;
                  Pach&oacute;n,&nbsp; E.R.,&nbsp; 2015. Comparative
                  techno-economic assessment and LCA of selected integrated
                  sugarcane-based biorefineries. Bioresour. Technol. 196,
                  364&ndash;375.
                </li>
                <li>
                  Goedkoop, M., Oele, M., Leijting, J., Ponsioen, T., Meijer,
                  E., 2013. Introduction to LCA with SimaPro. PR&eacute;.
                </li>
                <li>
                  Gomez, A., Rodrigues, M., Montanes, C., Dopazo, C., Fueyo, N.,
                  2010. The&nbsp; potential for electricity&nbsp;
                  generation&nbsp; from&nbsp; crop&nbsp; and&nbsp;
                  forestry&nbsp; residues&nbsp; in&nbsp; Spain. Biomass
                  Bioenergy 34,&nbsp; 703&ndash;719.
                </li>
                <li>
                  Gorniak-Zimroz, J., Pactwa, K., 2015. The&nbsp; use of&nbsp;
                  spatial data in granite deposit life cycle assessment.
                  Procedia. Earth. Planet. Sc. 15,&nbsp; 474&ndash;481.
                </li>
                <li>
                  Haase, M.,&nbsp; R&ouml;sch, C., Ketzer, D.,&nbsp; 2016.
                  GIS-based assessment&nbsp; of&nbsp; sustainable crop residue
                  potentials in European regions. Biomass Bioenergy 86,&nbsp;
                  156&ndash;171.
                </li>
                <li>
                  Hellweg, S., Canals, L.M.i., 2014. Emerging approaches,
                  challenges and opportunities in life&nbsp; cycle assessment.
                  Science 344, 1109&ndash;1113.
                </li>
                <li>
                  Herr,&nbsp; A.,&nbsp; Dunlop,&nbsp; M.,&nbsp; 2011.&nbsp;
                  Bioenergy in&nbsp; Australia:&nbsp; an&nbsp; improved&nbsp;
                  approach&nbsp; for estimating&nbsp;&nbsp; spatial&nbsp;&nbsp;
                  availability&nbsp; of&nbsp;&nbsp;&nbsp; biomass&nbsp;
                  resources&nbsp; in&nbsp; the&nbsp;&nbsp; agricultural
                  production zones. Biomass Bioenergy 35,&nbsp; 2298&ndash;2305.
                </li>
                <li>
                  Hiloidhari, M., Baruah, D.C., 2011. Crop residue biomass
                  for&nbsp; decentralized electrical power generation in rural
                  areas (part 1): investigation of&nbsp; spatial availability.
                  Renewable Sustainble Energy Rev.&nbsp; 15,&nbsp;
                  1885&ndash;1892.
                </li>
                <li>
                  Hiloidhari, M., Baruah, D., Mahilary, H., Baruah, D.C., 2012.
                  GIS based assessment of rice (Oryza sativa) straw biomass as
                  an alternative fuel for&nbsp; tea (Camellia sinensis L.)
                  drying in Sonitpur district of Assam, India. Biomass Bioenergy
                  44,&nbsp; 160&ndash;167.
                </li>
                <li>
                  Ho,&nbsp; D.P., Ngo,&nbsp; H.H.,&nbsp; Guo, W.,&nbsp; 2014. A
                  mini review on renewable sources for&nbsp; biofuel. Bioresour.
                  Technol. 169, 742&ndash;749.
                </li>
                <li>
                  H&ouml;hn, J., Lehtonen, E., Rasi,&nbsp; S., Rintala, J.,
                  2014. A Geographical Information System (GIS) based
                  methodology for&nbsp; determination of potential biomasses and
                  sites for biogas plants in southern Finland. Appl. Energy 113,
                  1&ndash;10.
                </li>
                <li>
                  Hua, M.-C.,&nbsp; Huang, A.-L., Wen, T.-H.,&nbsp; 2013.
                  GIS-based biomass resource utilization for&nbsp; rice straw
                  cofiring in the Taiwanese power market. Energy 55,&nbsp;
                  354&ndash;360.
                </li>
                <li>
                  Humpenoder, F., Schaldach, R., Cikovani, Y., Schebek, L.,
                  2013. Effects of&nbsp; land-use change on the carbon balance
                  of&nbsp; 1st generation biofuels: an analysis for&nbsp; the
                  European Union combining spatial modeling and LCA. Biomass
                  Bioenergy 56, 166&ndash;178. The&nbsp;&nbsp;
                  International&nbsp;&nbsp; Renewable&nbsp; Energy Agency
                  (IRENA),&nbsp;&nbsp; 2015.&nbsp; Global bioenergy supply and
                  demand projections.&lt; http://www.irena.org/&gt;.
                </li>
                <li>
                  Jiang, D., Zhuang, D., Fu, J., Huang, Y., Wen, K., 2012.
                  Bioenergy potential from crop residues in China: availability
                  and distribution. Renewable Sustainble Energy Rev.&nbsp;
                  16,&nbsp; 1377&ndash;1382.
                </li>
                <li>
                  Kaundinya, D.P., Balachandra, P., Ravindranath, N.H.,&nbsp;
                  Ashok, V., 2013. A GIS (geographical information&nbsp;
                  system)-based&nbsp; spatial&nbsp; data&nbsp; mining&nbsp;
                  approach&nbsp; for optimal&nbsp;&nbsp; location&nbsp;
                  and&nbsp;&nbsp; capacity&nbsp; planning&nbsp;
                  of&nbsp;&nbsp;&nbsp; distributed&nbsp;&nbsp; biomass&nbsp;
                  power generation facilities: a case study of Tumkur district,
                  India. Energy 52,&nbsp; 77&ndash;88.
                </li>
                <li>
                  Kimming, M.,&nbsp; Sundberg, C., Nordberg, &Aring;., Baky, A.,
                  Bernesson, S., Nor&eacute;n, O., et&nbsp; al., 2011. Biomass
                  from agriculture in small-scale combined heat and power plants
                  &ndash; a comparative life&nbsp; cycle assessment.&nbsp;
                  Biomass Bioenergy 35,&nbsp; 1572&ndash;1581.
                  Kurka,&nbsp;&nbsp; T.,&nbsp;&nbsp; Jefferies,&nbsp; C.,&nbsp;
                  Blackwood,&nbsp; D.,&nbsp;&nbsp; 2012.&nbsp; GIS-based
                  location&nbsp; suitability&nbsp; of decentralized, medium
                  scale bioenergy developments to estimate transport CO2
                  emissions and costs. Biomass Bioenergy 46,&nbsp;
                  366&ndash;379.
                </li>
                <li>
                  Kuzevicˇov&aacute;,&nbsp; Zˇ .,&nbsp;&nbsp;
                  Gergel&rsquo;ov&aacute;,&nbsp; M.,&nbsp;&nbsp;
                  Na&scaron;cˇ&aacute;kov&aacute;,&nbsp; J.,&nbsp; Kuzevicˇ
                  ,&nbsp;&nbsp; &Scaron;.,&nbsp;&nbsp; 2013.&nbsp;
                  Proposal&nbsp; of methodology for&nbsp;&nbsp; determining
                  of&nbsp;&nbsp; potential&nbsp; residual biomass
                  for&nbsp;&nbsp; agriculture and forestry in Slovak republic.
                  Acta. Montan. Slovaca. 18,&nbsp; 9&ndash;16.
                </li>
                <li>
                  Lapola, D.M., Schaldach, R., Alcamo, J., Bondeau, A., Koch,
                  J., Koelking, C., et al., 2010. Indirect land-use changes can
                  overcome carbon savings from biofuels in Brazil. Proc. Natl.
                  Acad. Sci.&nbsp; 107, 3388&ndash;3393.
                </li>
                <li>
                  Lin,&nbsp; T.,&nbsp; Rodr&iacute;guez, L.F.,&nbsp; Shastri,
                  Y.N.,&nbsp; Hansen, A.C.,&nbsp; Ting,&nbsp;&nbsp; K.C.,&nbsp;
                  2013.&nbsp; GIS-enabled biomass-ethanol&nbsp;&nbsp;
                  supply&nbsp;&nbsp; chain&nbsp;&nbsp; optimization:&nbsp;&nbsp;
                  model&nbsp;&nbsp; development&nbsp;&nbsp; and Miscanthus
                  application. Biofuels, Bioprod. Biorefin. 7, 314&ndash;333.
                </li>
                <li>
                  Liska,&nbsp; A.J., Yang, H.,&nbsp; Milner, M.,&nbsp; Goddard,
                  S., Blanco-Canqui, H., Pelton, M.P.,&nbsp; 2014. Biofuels from
                  crop residue can reduce soil carbon and increase CO2&nbsp;
                  emissions. Nat. Clim. Change. 4, 398&ndash;401.
                </li>
                <li>
                  Long,&nbsp;&nbsp;&nbsp;&nbsp; H.,&nbsp;&nbsp;&nbsp;
                  Li,&nbsp;&nbsp;&nbsp; X.,&nbsp;&nbsp;&nbsp; Wang,&nbsp;&nbsp;
                  H.,&nbsp;&nbsp;&nbsp; Jia,&nbsp;&nbsp;&nbsp;
                  J.,&nbsp;&nbsp;&nbsp; 2013.&nbsp; Biomass&nbsp;
                  resources&nbsp; and&nbsp;&nbsp; their bioenergy
                  potential&nbsp; estimation:&nbsp; a review. Renewable
                  Sustainble Energy Rev. 26,&nbsp; 344&ndash;35
                </li>
                <li>
                  Lourinho, G., Brito, P., 2015. Assessment of biomass energy
                  potential in a region of
                  <br />
                  Portugal (Alto Alentejo). Energy 81,&nbsp; 189&ndash;201.
                </li>
                <li>
                  Mafakheri,&nbsp; F.,&nbsp;&nbsp; Nasiri,&nbsp; F.,&nbsp;&nbsp;
                  2014.&nbsp; Modeling&nbsp; of&nbsp;&nbsp;
                  biomass-to-energy&nbsp; supply&nbsp; chain operations:
                  applications, challenges and research directions. Energy
                  Policy 67,
                  <br />
                  116&ndash;126.
                </li>
                <li>
                  Malico, I., Carrajola, J., Gomes, C.P.,&nbsp; Lima, J.C.,
                  2016. Biomass residues for&nbsp; energy production&nbsp;
                  and&nbsp; habitat&nbsp; preservation.&nbsp; Case study&nbsp;
                  in&nbsp; a&nbsp; montado&nbsp; area&nbsp; in Southwestern
                  Europe. J. Clean. Prod. 112, 3676&ndash;3683. Messineo, A.,
                  Volpe, R., Marvuglia, A., 2012. Ligno-cellulosic biomass
                  exploitation for&nbsp; power generation:&nbsp; a case study in
                  Sicily. Energy 45,&nbsp; 613&ndash;625.
                </li>
                <li>
                  Monforti, F., B&oacute;dis, K., Scarlat, N., Dallemand, J.F.,
                  2013. The&nbsp; possible contribution of agricultural crop
                  residues to renewable energy targets in Europe: a spatially
                  explicit study. Renewable Sustainble Energy Rev.&nbsp;
                  19,&nbsp; 666&ndash;677. Muench, S., 2015. Greenhouse gas
                  mitigation potential of electricity from biomass. J. Clean.
                  Prod. 103, 483&ndash;490.
                </li>
                <li>
                  Muench,&nbsp; S.,&nbsp; Guenther,&nbsp; E.,&nbsp; 2013.&nbsp;
                  A&nbsp; systematic&nbsp; review&nbsp; of&nbsp;&nbsp;
                  bioenergy&nbsp; life&nbsp;&nbsp; cycle assessments.&nbsp;
                  Appl. Energy 112, 257&ndash;273.
                  <br />
                  Mutel,&nbsp; C.L.,&nbsp;&nbsp; Pfister,&nbsp; S.,&nbsp;&nbsp;
                  Hellweg,&nbsp; S.,&nbsp;&nbsp; 2012.&nbsp; GIS-based&nbsp;
                  regionalized&nbsp;&nbsp; life&nbsp;&nbsp;&nbsp; cycle
                  assessment:&nbsp; how&nbsp; big&nbsp;&nbsp;&nbsp;
                  is&nbsp;&nbsp; small&nbsp; enough?&nbsp; Methodology&nbsp;
                  and&nbsp; case&nbsp; study&nbsp; of electricity generation.
                  Environ. Sci.&nbsp; Technol. 46,&nbsp; 1096&ndash;1103.
                </li>
                <li>
                  Nguyen, T.L.T., Hermansen, J.E., Mogensen, L., 2013.
                  Environmental performance of crop residues as an energy source
                  for&nbsp; electricity production: the case of wheat straw in
                  Denmark. Appl. Energy 104, 633&ndash;641.
                </li>
                <li>
                  Perpina, C., Alfonso, D., Pe&rsquo;rez-Navarro, A., Penalvo,
                  E., Vargas, C., Cardenas, R., 2009. Methodology based on
                  Geographic Information Systems for&nbsp; biomass logistics and
                  transport optimisation. Renewable Energy 34,&nbsp;
                  555&ndash;565.
                </li>
                <li>
                  Plevin,&nbsp; R.J.,&nbsp;&nbsp; Delucchi,&nbsp;
                  M.A.,&nbsp;&nbsp; Creutzig,&nbsp; F.,&nbsp;&nbsp; 2014.&nbsp;
                  Using&nbsp; attributional&nbsp;&nbsp; life&nbsp;&nbsp;&nbsp;
                  cycle assessment&nbsp; to&nbsp; estimate&nbsp; climate-change
                  mitigation benefits misleads policy makers. J. Ind.
                  Ecol.&nbsp; 18,&nbsp; 73&ndash;83.
                </li>
                <li>
                  Ramachandra, T.V., Krishna, S.V., Shruthi, B.V., 2005.
                  Decision support system to assess regional biomass energy
                  potential. Int.&nbsp; J. Green Energy 1, 407&ndash;428.
                  Ramjeawon, T., 2008. Life cycle assessment of electricity
                  generation from bagasse in
                </li>
                <li>
                  Mauritius. J. Clean. Prod. 16,&nbsp; 1727&ndash;1734. Rathore,
                  D., Pant, D., Singh, A., 2013. A comparison of life&nbsp;
                  cycle assessment studies of&nbsp;&nbsp; different&nbsp;
                  biofuels.&nbsp; In:&nbsp;&nbsp; Singh,&nbsp; A.,&nbsp;
                  Pant,&nbsp; D.,&nbsp;&nbsp; Olsen,&nbsp; S.I.&nbsp;&nbsp;
                  (Eds.),&nbsp; Life&nbsp;&nbsp; Cycle Assessment&nbsp;
                  of&nbsp;&nbsp; Renewable&nbsp; Energy&nbsp; Sources.&nbsp;
                  Green&nbsp; Energy&nbsp; and&nbsp; Technology Series.
                  Springer-Verlag, London.
                </li>
                <li>
                  Reap, J., Roman, F., Duncan, S., Bras, B., 2008. A survey of
                  unresolved problems in life cycle assessment part 1: goal and
                  scope and inventory analysis. Int.&nbsp; J. Life Cycle Assess.
                  13,&nbsp; 290&ndash;300.
                </li>
                <li>
                  Roostaei, J., Zhang, Y., 2016. Spatially explicit life&nbsp;
                  cycle assessment: opportunities and challenges of&nbsp;
                  wastewater-based&nbsp; algal biofuels in the United States.
                  Algal. Res.&nbsp; 10.1016/j.algal.2016.08.008.
                </li>
                <li>
                  Sacchelli,&nbsp; S.,&nbsp;&nbsp; Meob,&nbsp; I.D.,&nbsp;&nbsp;
                  Palett,&nbsp; A.,&nbsp;&nbsp; 2013.&nbsp; Bioenergy
                  production&nbsp; and&nbsp; forest multifunctionality: a
                  trade-off analysis using multiscale GIS&nbsp; model in a case
                  study in Italy. Appl. Energy 104, 10&ndash;20.
                </li>
                <li>
                  Sanscartier, D., Dias, G., Deen, B., Dadfar, H., McDonald, I.,
                  MacLean, H.L., 2014. Life cycle greenhouse&nbsp; gas
                  emissions&nbsp; of&nbsp; electricity generation from corn cobs
                  in Ontario, Canada. Biofuels. Bioprod. Biorefin. 8,
                  568&ndash;578.
                </li>
                <li>
                  Searchinger, T., Heimlich, R., Houghton, R.A., Dong, F.,
                  Elobeid, A., Fabiosa, J., et al., 2008. Use&nbsp;&nbsp;
                  of&nbsp; U.S.&nbsp; croplands for&nbsp; biofuels increases
                  greenhouse gases through emissions from land-use change.
                  Science 319, 1238&ndash;1240.
                </li>
                <li>
                  Sebasti&aacute;n, F., Royo, J., G&oacute;mez, M., 2011.
                  Cofiring versus biomass-fired power plants: GHG&nbsp;
                  (Greenhouse Gases) emissions savings comparison by&nbsp; means
                  of LCA (Life Cycle Assessment) methodology. Energy 36,&nbsp;
                  2029&ndash;2037.
                </li>
                <li>
                  Shafie, S.M., Masjuki, H.H.,&nbsp; Mahlia, T.M.I., 2014. Life
                  cycle assessment of rice straw- based power generation in
                  Malaysia. Energy 70,&nbsp; 401&ndash;410.
                </li>
                <li>
                  Shi,&nbsp; X., Elmore, A., Li, X., Gorence, N.J., Jin,&nbsp;
                  H., Zhang, X., et al.,&nbsp; 2008. Using spatial information
                  technologies to select sites for&nbsp; biomass power plants: a
                  case study in Guangdong Province, China. Biomass Bioenergy
                  32,&nbsp; 35&ndash;43. Silalertruksa, T., Gheewala,
                  S.H.,&nbsp; 2013. A comparative LCA of&nbsp; rice straw
                  utilization
                  <br />
                  for&nbsp; fuels and fertilizer in Thailand. Bioresour.
                  Technol. 50,&nbsp; 412&ndash;419.
                </li>
                <li>
                  Singh, A.,&nbsp; Olsen, S.I.,&nbsp; 2012. Key&nbsp;&nbsp;
                  issues in life&nbsp;&nbsp; cycle assessment&nbsp; of&nbsp;
                  biofuels. In: Gopalakrishnan, K. et al.&nbsp; (Eds.),
                  Sustainable Bioenergy and Bioproducts, Green Energy and&nbsp;
                  Technology. Springer-Verlag, London Limited.
                  http://dx.doi.org/ 10.1007/978-1-4471-2324-8_11.
                </li>
                <li>
                  Singh, A., Nizami, A., Korres, N.E., Murphy, J.D., 2011.
                  The&nbsp; effect of reactor design on the sustainability
                  of&nbsp; grass biomethane. Renewable Sustainble Energy
                  Rev.&nbsp; 15, 1567&ndash;1574.
                </li>
                <li>
                  Singh, J., Panesar, B.S., Sharma, S.K., 2011. Geographical
                  distribution of agricultural residues and optimum sites of
                  biomass based power plant in Bathinda, Punjab. Biomass
                  Bioenergy 35,&nbsp; 4455&ndash;4460.
                </li>
                <li>
                  Singh, A., Olsen, S.I., Pant, D., 2013. Importance of
                  life&nbsp; cycle assessment of renewable energy sources.
                  In:&nbsp; Singh, A. et al.&nbsp; (Eds.), Life&nbsp; Cycle
                  Assessment&nbsp; of&nbsp; Renewable Energy Sources, Green
                  Energy and Technology. Springer-Verlag, London. http://
                  dx.doi.org/10.1007/978-1-4471-5364-1_1.
                </li>
                <li>
                  Soam, S., Borjesson, P., Sharma, P.K., Gupta, R.P.,
                  Tuli,&nbsp; D.K., Kumar, R., 2017. Life cycle assessment of
                  rice straw utilization practices in India. Bioresour. Technol.
                  228, 89&ndash;98.
                </li>
                <li>
                  Stephen, J.D., Sokhansanj, S., Bi, X., Sowlati, T., Kloeck,
                  T., Townley-Smith, L., et al.,
                  <br />
                  2010. Analysis of&nbsp; biomass feedstock availability and
                  variability for&nbsp; the Peace River region of Alberta,
                  Canada. Biosys. Eng.&nbsp; 105, 103&ndash;111.
                </li>
                <li>
                  Sultana, A., Kumar, A., 2012. Optimal siting and size of&nbsp;
                  bioenergy facilities using geographic information system.
                  Appl. Energy 94,&nbsp; 192&ndash;201.
                  <br />
                  Tiba, C., Candeias, A.L.B., Fraidenraich, N., de Barbosa,
                  E.M.S., Neto, P.B., de,&nbsp; C., Filho,
                </li>
                <li>
                  J.B.,&nbsp; de,&nbsp;&nbsp; M.,&nbsp; 2010. A&nbsp; GIS-based
                  decision support&nbsp; tool for&nbsp;&nbsp; renewable energy
                  management and planning in semi-arid rural environments
                  of&nbsp; northeast&nbsp; of Brazil. Renewable Energy 35,&nbsp;
                  2921&ndash;2932.
                </li>
                <li>
                  Tilman, D., Socolow, R., Foley, J.A., Hill,&nbsp; J., Larson,
                  E., Lynd, L., et al.,&nbsp; 2009. Beneficial
                  biofuels-The&nbsp;&nbsp; food,&nbsp;&nbsp; energy,&nbsp;&nbsp;
                  and&nbsp;&nbsp;&nbsp; environment&nbsp;&nbsp;&nbsp;
                  trilemma.&nbsp;&nbsp;&nbsp; Science&nbsp;&nbsp; 325,
                  270&ndash;271.
                </li>
                <li>
                  Tonini, D.,&nbsp; Hamelin, L.,&nbsp; Alvarado-Morales,
                  M.,&nbsp; Astrup, T.F.,&nbsp; 2016. GHG&nbsp;&nbsp; emission
                  factors for&nbsp; bioelectricity, biomethane, and bioethanol
                  quantified for&nbsp; 24 biomass substrates&nbsp; with
                  consequential&nbsp; life-cycle assessment. Bioresour. Technol.
                  208,
                  <br />
                  123&ndash;133.
                </li>
                <li>
                  Tsiropoulos, I.,&nbsp; Faaij, A.P.C.,&nbsp; Seabra, J.E.A.,
                  Lundquist, L., Schenker, U.,&nbsp; Briois,&nbsp; J.-F., Patel,
                  M.K., 2014. Life cycle assessment of sugarcane ethanol
                  production in India in comparison to Brazil. Int.&nbsp; J.
                  Life Cycle Assess. 19,&nbsp; 1049&ndash;1067. World&nbsp;
                  Bioenergy Association, 2015.&nbsp; World&nbsp; Bioenergy
                  Statistics&nbsp; 2015.&nbsp; &lt;http://
                  www.worldbioenergy.org&gt;. (accessed 10.10.15).
                </li>
                <li>
                  Yu, H., Wang, Q., Ileleji, K.E., Yu, C., Luo, Z., Cen,&nbsp;
                  K., et al., 2012. Design and analysis of geographic
                  distribution of biomass power plant and satellite storages in
                  China. Part 1: straight-line delivery. Biomass Bioenergy
                  46,&nbsp; 773&ndash;784.
                </li>
                <li>
                  Yue, C., Wang, S., 2006. GIS-based evaluation of multifarious
                  local renewable energy sources: a case study of the Chigu area
                  of southwestern Taiwan. Energy Policy 34,&nbsp; 730&ndash;742.
                </li>
                <li>
                  Zubaryeva,&nbsp; A.,&nbsp; Zaccarelli,&nbsp; N.,&nbsp;&nbsp;
                  Giudice,&nbsp; C.D.,&nbsp; Zurlini,&nbsp; G.,&nbsp;
                  2012.&nbsp; Spatially explicit assessment of&nbsp; local
                  biomass availability for&nbsp; distributed&nbsp; biogas
                  production via anaerobic co-digestion &ndash; Mediterranean
                  case study. Renewable Energy 39,&nbsp; 261&ndash; 270.
                </li>
              </ol>
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
